import { RouteConfig } from "@abaco/web-common/src/app";

export type BreadCrumb = { text: string; link?: string };

function breadCrumb(params: { [key: string]: string }, isSingleSubject = true): BreadCrumb[] {
    const ret: BreadCrumb[] = [];
    if (!isSingleSubject) {
        ret.push({
            text: "subject-list",
            link: "/"
        });
    }
    ret.push({
        text: "contracts-list",
        link: `/subject/${encodeURIComponent(params.subjectId)}/contracts`
    });

    ret.push({
        text: "Project Proposal",
        link: `/subject/${encodeURIComponent(params.subjectId)}/project-proposal/${encodeURIComponent(
            params.applicationId
        )}`
    });
    return ret;
}

const children: RouteConfig[] = [
    {
        name: "project-proposal-home",
        path: "/",
        component: () => import("./components/ProjectProposal/ProjectProposalHome.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_1",
        path: ":pageCode/details",
        component: () => import("./components/ProjectProposal/ProjectProposalDetails.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_10",
        path: ":pageCode/Clarification",
        component: () => import("./components/ProjectProposal/ProjectProposalPsc_Clarification.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_11",
        path: ":pageCode/decisionletter",
        component: () => import("./components/ProjectProposal/ProjectProposalDecisionLetter.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_2-173_3_01",
        path: ":pageCode/sector-type-infrastructure",
        component: () => import("./components/ProjectProposal/ProjectProposalSectorTypeInfrastructure.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_2-173_4_01",
        path: ":pageCode/sector-type-productive-investment",
        component: () => import("./components/ProjectProposal/ProjectProposalSectorTypeProductiveInvestment.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_2-173_5_01",
        path: ":pageCode/sector-type-investment-on-farm",
        component: () => import("./components/ProjectProposal/ProjectProposalSectorTypeInvestmentOnFarm.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_2-175_1_01",
        path: ":pageCode/sector-type-young-farmers",
        component: () => import("./components/ProjectProposal/ProjectProposalSectorTypeYoungFarmers.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_3",
        path: ":pageCode/line-items",
        component: () => import("./components/ProjectProposal/ProjectProposalLineItems.vue"),
        redirect: { name: "project-proposal-line-items-list" },
        props: true,
        meta: {
            breadCrumb
        },
        children: [
            {
                name: "project-proposal-line-items-list",
                path: "list",
                component: () => import("./components/ProjectProposal/ProjectProposalLineItemsList.vue"),
                props: true,
                meta: {
                    breadCrumb(params: { [key: string]: string }, isSingleSubject?: boolean) {
                        const ret: BreadCrumb[] = breadCrumb(params, isSingleSubject);
                        ret.push({
                            text: "Line Items",
                            link: `/subject/${encodeURIComponent(
                                params.subjectId
                            )}/project-proposal/${encodeURIComponent(params.applicationId)}/line-items`
                        });
                        return ret;
                    }
                }
            },
            {
                name: "project-proposal-line-items-edit",
                path: ":itemId/edit",
                component: () => import("./components/ProjectProposal/ProjectProposalLineItemsEdit.vue"),
                props: true,
                meta: {
                    breadCrumb(params: { [key: string]: string }, isSingleSubject?: boolean) {
                        const ret: BreadCrumb[] = breadCrumb(params, isSingleSubject);

                        ret.push({
                            text: "Line Items",
                            link: `/subject/${encodeURIComponent(
                                params.subjectId
                            )}/project-proposal/${encodeURIComponent(params.applicationId)}/line-items`
                        });

                        ret.push({
                            text: "Edit",
                            link: `/subject/${encodeURIComponent(
                                params.subjectId
                            )}/project-proposal/${encodeURIComponent(params.applicationId)}/line-items/${
                                params.itemId
                            }/edit`
                        });

                        return ret;
                    }
                }
            },
            {
                name: "project-proposal-line-items-quotation-edit",
                path: ":itemId/quotation/:quotationId/edit",
                component: () => import("./components/ProjectProposal/ProjectProposalLineItemsQuotationEdit.vue"),
                props: true,
                meta: {
                    breadCrumb(params: { [key: string]: string }, isSingleSubject?: boolean) {
                        const ret: BreadCrumb[] = breadCrumb(params, isSingleSubject);

                        ret.push({
                            text: "Line Items",
                            link: `/subject/${encodeURIComponent(
                                params.subjectId
                            )}/project-proposal/${encodeURIComponent(params.applicationId)}/line-items`
                        });

                        ret.push({
                            text: "Edit",
                            link: `/subject/${encodeURIComponent(
                                params.subjectId
                            )}/project-proposal/${encodeURIComponent(params.applicationId)}/line-items/${
                                params.itemId
                            }/edit`
                        });

                        ret.push({
                            text: "Quotation",
                            link: `/subject/${encodeURIComponent(
                                params.subjectId
                            )}/project-proposal/${encodeURIComponent(params.applicationId)}/line-items/${
                                params.itemId
                            }/quotation/${params.quotationId}/edit`
                        });

                        return ret;
                    }
                }
            }
        ]
    },
    {
        name: "project-proposal-page_4-173_3_01",
        path: ":pageCode/formb-questions-infrastructure",
        component: () => import("./components/ProjectProposal/ProjectProposalFormBInfrastructure.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_4-173_4_01",
        path: ":pageCode/formb-questions-productive-investment",
        component: () => import("./components/ProjectProposal/ProjectProposalFormBProductive.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_4-173_5_01",
        path: ":pageCode/formb-questions-productive-investment-on-farm",
        component: () => import("./components/ProjectProposal/ProjectProposalFormBProductiveOnFarm.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_4-175_1_01",
        path: ":pageCode/formb-questions-young-farmer",
        component: () => import("./components/ProjectProposal/ProjectProposalFormBYoungFarmer.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_4-177_2_01",
        path: ":pageCode/formb-questions-cooperation",
        component: () => import("./components/ProjectProposal/ProjectProposalFormBCooperation.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "dynamic-form",
        path: ":pageCode/form",
        component: () => import("./components/ProjectProposal/ProjectProposalFormB.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_5",
        path: ":pageCode/standard-output",
        component: () => import("./components/ProjectProposal/ProjectProposalStandardOutput.vue"),
        redirect: { name: "project-proposal-standard-output-list" },
        props: true,
        meta: {
            breadCrumb
        },
        children: [
            {
                name: "project-proposal-standard-output-list",
                path: "list",
                component: () => import("./components/ProjectProposal/ProjectProposalStandardOutputList.vue"),
                props: true,
                meta: {
                    breadCrumb(params: { [key: string]: string }, isSingleSubject?: boolean) {
                        const ret: BreadCrumb[] = breadCrumb(params, isSingleSubject);
                        ret.push({
                            text: "Standard Output",
                            link: `/subject/${encodeURIComponent(
                                params.subjectId
                            )}/project-proposal/${encodeURIComponent(params.applicationId)}/standard-output`
                        });
                        return ret;
                    }
                }
            },
            {
                name: "project-proposal-standard-output-edit",
                path: ":itemId/edit",
                component: () => import("./components/ProjectProposal/ProjectProposalStandardOutputEdit.vue"),
                props: true,
                meta: {
                    breadCrumb(params: { [key: string]: string }, isSingleSubject?: boolean) {
                        const ret: BreadCrumb[] = breadCrumb(params, isSingleSubject);

                        ret.push({
                            text: "Standard Output",
                            link: `/subject/${encodeURIComponent(
                                params.subjectId
                            )}/project-proposal/${encodeURIComponent(params.applicationId)}/standard-output`
                        });

                        ret.push({
                            text: "Edit",
                            link: `/subject/${encodeURIComponent(
                                params.subjectId
                            )}/project-proposal/${encodeURIComponent(params.applicationId)}/standard-output/${
                                params.itemId
                            }/edit`
                        });

                        return ret;
                    }
                }
            }
        ]
    },

    {
        name: "project-proposal-page_6-173_3_01",
        path: ":pageCode/supporting-documents-infrastructure",
        component: () => import("./components/ProjectProposal/ProjectProposalSupportingDocumentsInfrastructure.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_6-173_4_01",
        path: ":pageCode/supporting-documents-productive-investment",
        component: () =>
            import("./components/ProjectProposal/ProjectProposalSupportingDocumentsProductiveInvestment.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_6-173_5_01",
        path: ":pageCode/supporting-documents-productive-on-farm",
        component: () => import("./components/ProjectProposal/ProjectProposalSupportingDocumentsProductiveOnFarm.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_6-175_1_01",
        path: ":pageCode/supporting-documents-young-farmers",
        component: () => import("./components/ProjectProposal/ProjectProposalSupportingDocumentsYoungFarmers.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_6-177_2_01",
        path: ":pageCode/supporting-documents-cooperation",
        component: () => import("./components/ProjectProposal/ProjectProposalSupportingDocumentsCooperation.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_7",
        path: ":pageCode/declarations",
        component: () => import("./components/ProjectProposal/ProjectProposalDeclarations.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_8",
        path: ":pageCode/location-investment-on-farm",
        component: () => import("./components/ProjectProposal/ProjectProposalLocationInvestmentOnFarm.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    },
    {
        name: "project-proposal-page_9",
        path: ":pageCode/eip",
        component: () => import("./components/ProjectProposal/ProjectProposalEIPOperationGroup.vue"),
        props: true,
        meta: {
            breadCrumb
        }
    }
];

const routes: RouteConfig[] = [
    {
        path: "/subject/:subjectId/project-proposal/:applicationId",
        component: () => import("./components/ProjectProposal/ProjectProposal.vue"),
        props: true,
        meta: {
            breadCrumb
        },
        children
    },
    {
        path: "/subject/:subjectId/project-proposal/",
        component: () => import("./components/ProjectProposal/ProjectProposal.vue"),
        props: true,
        meta: {
            breadCrumb
        },
        children: [
            {
                name: "project-proposal-new",
                path: "new",
                component: () => import("./components/ProjectProposal/ProjectProposalNew.vue"),
                props: true,
                meta: {
                    breadCrumb
                }
            }
        ]
    }
];

export default routes;
